// Packages page scaffold (plans/bundles/pricing).
import PackagesGrid from "../components/sections/packages/PackagesGrid";
import PackagesCTA from "../components/sections/packages/PackagesCTA";
import { useLanguage } from "../i18n/LanguageContext";

export default function PackagesPage() {
  const { t } = useLanguage();

  return (
    <div className="packages-page">
      <section className="hero">
        <svg
          className="hero-pattern"
          viewBox="0 0 680 400"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
        >
          <g opacity="0.13">
            <rect
              x="10"
              y="10"
              width="28"
              height="9"
              rx="2"
              fill="#411428"
              transform="rotate(-55 10 10)"
            />
            <rect
              x="60"
              y="40"
              width="38"
              height="9"
              rx="2"
              fill="#FF4B32"
              transform="rotate(15 60 40)"
            />
            <rect
              x="110"
              y="8"
              width="18"
              height="9"
              rx="2"
              fill="#411428"
              transform="rotate(-80 110 8)"
            />
            <rect
              x="155"
              y="55"
              width="34"
              height="9"
              rx="2"
              fill="#733635"
              transform="rotate(30 155 55)"
            />
            <rect
              x="210"
              y="15"
              width="26"
              height="9"
              rx="2"
              fill="#FF4B32"
              transform="rotate(-40 210 15)"
            />
            <rect
              x="270"
              y="70"
              width="40"
              height="9"
              rx="2"
              fill="#411428"
              transform="rotate(10 270 70)"
            />
            <rect
              x="330"
              y="5"
              width="22"
              height="9"
              rx="2"
              fill="#733635"
              transform="rotate(-70 330 5)"
            />
            <rect
              x="395"
              y="45"
              width="36"
              height="9"
              rx="2"
              fill="#FF4B32"
              transform="rotate(45 395 45)"
            />
            <rect
              x="455"
              y="20"
              width="28"
              height="9"
              rx="2"
              fill="#411428"
              transform="rotate(-20 455 20)"
            />
            <rect
              x="515"
              y="80"
              width="32"
              height="9"
              rx="2"
              fill="#733635"
              transform="rotate(60 515 80)"
            />
            <rect
              x="575"
              y="12"
              width="24"
              height="9"
              rx="2"
              fill="#FF4B32"
              transform="rotate(-50 575 12)"
            />
            <rect
              x="630"
              y="50"
              width="38"
              height="9"
              rx="2"
              fill="#411428"
              transform="rotate(25 630 50)"
            />
            <rect
              x="30"
              y="90"
              width="30"
              height="9"
              rx="2"
              fill="#FF4B32"
              transform="rotate(-65 30 90)"
            />
            <rect
              x="180"
              y="95"
              width="26"
              height="9"
              rx="2"
              fill="#733635"
              transform="rotate(40 180 95)"
            />
            <rect
              x="380"
              y="100"
              width="20"
              height="9"
              rx="2"
              fill="#FF4B32"
              transform="rotate(-30 380 100)"
            />
            <rect
              x="500"
              y="105"
              width="34"
              height="9"
              rx="2"
              fill="#411428"
              transform="rotate(15 500 105)"
            />
            <rect
              x="20"
              y="200"
              width="32"
              height="9"
              rx="2"
              fill="#733635"
              transform="rotate(-45 20 200)"
            />
            <rect
              x="90"
              y="230"
              width="28"
              height="9"
              rx="2"
              fill="#FF4B32"
              transform="rotate(20 90 230)"
            />
            <rect
              x="200"
              y="190"
              width="36"
              height="9"
              rx="2"
              fill="#411428"
              transform="rotate(-60 200 190)"
            />
            <rect
              x="320"
              y="250"
              width="24"
              height="9"
              rx="2"
              fill="#733635"
              transform="rotate(35 320 250)"
            />
            <rect
              x="440"
              y="210"
              width="30"
              height="9"
              rx="2"
              fill="#FF4B32"
              transform="rotate(-25 440 210)"
            />
            <rect
              x="560"
              y="240"
              width="38"
              height="9"
              rx="2"
              fill="#411428"
              transform="rotate(50 560 240)"
            />
            <rect
              x="15"
              y="320"
              width="26"
              height="9"
              rx="2"
              fill="#FF4B32"
              transform="rotate(-40 15 320)"
            />
            <rect
              x="140"
              y="350"
              width="34"
              height="9"
              rx="2"
              fill="#733635"
              transform="rotate(25 140 350)"
            />
            <rect
              x="280"
              y="310"
              width="22"
              height="9"
              rx="2"
              fill="#411428"
              transform="rotate(-70 280 310)"
            />
            <rect
              x="420"
              y="360"
              width="30"
              height="9"
              rx="2"
              fill="#FF4B32"
              transform="rotate(15 420 360)"
            />
            <rect
              x="590"
              y="330"
              width="28"
              height="9"
              rx="2"
              fill="#733635"
              transform="rotate(-55 590 330)"
            />
          </g>
        </svg>

        <h1 className="hero__title">{t.packages.heroTitle}</h1>
        <p className="hero__text">{t.packages.heroText}</p>
      </section>

      <main className="packages">
        <div className="container">
          <h2 className="section-title">{t.packages.sectionTitle}</h2>
          <p className="section-subtitle">{t.packages.sectionSubtitle}</p>

          <PackagesGrid packages={t.packages.cards} />

          <div className="note" data-aos="fade-up">
            <h3>{t.packages.noteTitle}</h3>
            <p>{t.packages.noteText}</p>
          </div>
        </div>
      </main>

      <PackagesCTA
        title={t.packages.bottomCtaTitle}
        text={t.packages.bottomCtaText}
        buttonText={t.packages.bottomCtaBtn}
      />
    </div>
  );
}

